import * as ACTIONS from "@iso/redux/locations/actionTypes";

const initialState = {
  locations: {
    list: [],
    total: 0,
  },
};

function locationsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        ...{ locations: payload },
      };
    }

    default:
      return state;
  }
}

export default locationsReducer;
